export enum GoodsFamily {
  ALUMINIUM = 'ALUMINIUM',
  CEMENT = 'CEMENT',
  IRONANDSTEEL = 'IRONANDSTEEL',
  ELECTRICITY = 'ELECTRICITY',
  CHEMICALS = 'CHEMICALS',
  FERTILIZERS = 'FERTILIZERS'
}

export enum ReportingPeriodBasis {
  CALENDAR_YEAR = 'CALENDAR_YEAR',
  FISCAL_YEAR = 'FISCAL_YEAR',
  DEFINED_BY_ELIGIBLE_MONITORING_AND_VERIFICATION_SCHEME = 'DEFINED_BY_ELIGIBLE_MONITORING_AND_VERIFICATION_SCHEME'
}

export const DEFAULT_CALENDAR_YEAR_REPORTING_PERIOD = {
  basisForReportingPeriod: ReportingPeriodBasis.CALENDAR_YEAR,
  startMonth: 1,
  monthInterval: 12
} as const
